import { PassengerSelectionTile } from "../components";
import { useSSRContext } from "../../../context/SSRContext";
import classNames from "classnames";

export default function PassengerSelectionWeb() {
  const { cursor, passengerOptions, handleChange } = useSSRContext();

  return (
    <div className="flex flex-col gap-4 px-2">
      <div className="text-lg font-semibold">Who's Choosing</div>
      <div className="flex flex-col gap-2">
        {passengerOptions.map((passenger) => {
          const isActive = passenger.value === cursor.passengerId;
          return (
            <div
              onClick={handleChange("passengerId", passenger.value)}
              key={passenger.value}
              className={classNames(
                "rounded-xs bg-background-default flex cursor-pointer items-center p-4 outline-1 transition-all duration-300",
                isActive ? "outline-border-active":"outline-dashed outline-border-subtle",
              )}
            >
              <PassengerSelectionTile passenger={passenger} isActive={isActive} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
